import { LOGIN } from 'lib/routes'
import React from 'react'
import { Navigate } from 'react-router-dom'

const LandingPage = () => {
    return (
        <div>
            <Navigate to={LOGIN} />
            <p style={{ 'color': '#fff', padding: '20px' }}>Hey! Estamos desarrollando nuestra presentación.</p>
        </div >
    )
}

export default LandingPage